import api from '~/services/api'

export const saveStatistic = async (sessionId: string, qrType: string) => {
  await api.put(`session/${sessionId}/qr-type`, { qr_type: qrType })
}
